import React, { useContext } from 'react';
import TabsListLayout from '../components/layout/tabs-list-layout';
import TabsList from '../components/tabs-list';
import { VARIANTS } from '../components/tabs-list/constants';
import TabsContext from '../context/tabs-context';
const TabsListContainer = ({ children, variant = VARIANTS.scrollable }) => {
  const { appearance, activeTabId, activeTabManager, noBackground } = useContext(TabsContext);

  return (
    <TabsListLayout>
      <TabsList
        appearance={appearance}
        variant={variant}
        activeTabManager={activeTabManager}
        // @ts-ignore Property 'activeTabId' does not exist on type 'IntrinsicAttributes & TabsListProps'.ts(2322)
        activeTabId={activeTabId}
        noBackground={noBackground}
      >
        {children}
      </TabsList>
    </TabsListLayout>
  );
};

export default TabsListContainer;
